import { Styles } from 'react-jss'
import { fieldStatusAppearence } from '../sheet'

export const sheet: Styles = {
  root: {},
  rootFocused: {},
  selected: {},
  selectedTag: {},
  longTag: {},
  search: {},
  searchInput: {},
  suggestions: {},
  heightAuto: {},
  error: {},
  main: {
    '& > $root': {
      padding: '0 0 0 10px',
      minHeight: 131,
      ...fieldStatusAppearence.base,

      '& > $selected': {
        display: 'inline',
        border: 'none',
        boxShadow: 'none',
        '& > $selectedTag': {
          border: 'none',
          boxShadow: 'none',
          background: '#D8ECFF',
          fontWeight: '500',
          lineHeight: '18px',
          fontSize: 13,
          letterSpacing: '0.03em',
          textTransform: 'capitalize',
          wordBreak: 'break-all',
          padding: '4px 10px',
          display: 'inline-block',
          boxSizing: 'border-box',
          margin: '6px 10px 6px 0',
          '&:after': {
            content: '"\\2715"',
            color: '#989FA6',
            marginLeft: 10,
            fontWeight: '900'
          }
        },
        '& > $longTag': {
          border: '1px solid red'
        }
      },
      '& > $search': {
        '& > $searchInput': {
          '& > input': {
            ...fieldStatusAppearence.text,
            '&::placeholder': {
              ...fieldStatusAppearence.placeholder
            }
          }
        },
        '& > $suggestions': {
          left: 'auto',
          fontWeight: 'normal',
          lineHeight: '20px',
          fontSize: 15,
          letterSpacing: '0.01em',
          color: '#080910'
        }
      }
    },
    '& > $rootFocused': {
      ...fieldStatusAppearence.focused
      // border: '1px solid #85BFFF'
    },
    '& > $heightAuto': {
      minHeight: 'auto'
    },
    '& > $error': {
      ...fieldStatusAppearence.error,

      '&:focus, &:active': {
        ...fieldStatusAppearence.error
      }
    }
  }
}
